import { Component, Input, EventEmitter, Output, SimpleChanges, input } from '@angular/core';
import 'datatables.net';
import { DadosVenda, DetalhesContato, ParamRemoverDadosVenda } from '../../../../../interfaces/lista-contato/lista-contato.interface';
import { ContatosService } from '../../../../../services/contatos.service';
import { ToastrService } from 'ngx-toastr';
import { StringUtil } from '../../../../../infra/string-util';
import { EnumPermissao } from '../../../../../enums/permissoes.enum';
import { PermissaoService } from '../../../../../services/permissao.service';
import { SaldoUtil } from '../../../../../infra/saldo-util';
import { SaldoService } from '../../../../../services/saldo.service';
import { Router } from '@angular/router';
import { data, param } from 'jquery';
@Component({
    selector: 'app-modal-contato',
    templateUrl: './modal-contato.component.html',
    styleUrl: './modal-contato.component.css',
    standalone: false
})
export class ModalContatoComponent {
    EnumPermissao = EnumPermissao;
    @Input() idContato: string = '';
    @Input() idLista: number = 0;
    @Output() fecharDetalhes = new EventEmitter<void>();
    @Output() contatoConvertidoEvent = new EventEmitter<string>();
    @Output() contatoRemoverVendaEvent = new EventEmitter<string>();

    contato: DetalhesContato | undefined;

    showModal: boolean = false;
    processandoAnotacao: boolean = false;
    processandoVenda: boolean = false;
    carregando: boolean = false;
    stringUtil = StringUtil;
    contatoJaConvertido: boolean = false;
    margem: boolean | undefined;
    ehRemoverVenda: boolean = false;

    constructor(
        private contatosService: ContatosService,
        private toastr: ToastrService,
        public permissaoService: PermissaoService,
        private saldoService: SaldoService,
        private router: Router
    ) {
    }

    get parcelas(): number | undefined {
        return this.contato?.dadosVenda?.parcelas;
    }

    set parcelas(value: number | undefined) {
        if (this.contato && this.contato.dadosVenda) {
            this.contato.dadosVenda.parcelas = value;
        }
    }

    get dataInicioContrato(): Date | undefined {
        return this.contato?.dadosVenda?.dataInicioContrato;
    }

    set dataInicioContrato(value: Date | undefined) {
        if (this.contato && this.contato.dadosVenda) {
            this.contato.dadosVenda.dataInicioContrato = value;
        }
    }

    get dataFimContrato(): Date | undefined {
        return this.contato?.dadosVenda?.dataFimContrato;
    }

    set dataFimContrato(value: Date | undefined) {
        if (this.contato && this.contato.dadosVenda) {
            this.contato.dadosVenda.dataFimContrato = value;
        }
    }

    get dataInicialFormatada(): string {
        if (!this.contato?.dadosVenda?.dataInicioContrato) return '';
        const data = new Date(this.contato.dadosVenda.dataInicioContrato);
        return data.toISOString().split('T')[0];
    }

    set dataInicialFormatada(value: string) {
        if (!this.contato?.dadosVenda) return;

        if (!value) {
            this.contato.dadosVenda.dataInicioContrato = undefined;
            return;
        }

        this.contato.dadosVenda.dataInicioContrato = new Date(value);
    }

    get dataFinalFormatada(): string {
        if (!this.contato?.dadosVenda?.dataFimContrato) return '';
        const data = new Date(this.contato.dadosVenda.dataFimContrato);
        return data.toISOString().split('T')[0];
    }

    set dataFinalFormatada(value: string) {
        if (!this.contato?.dadosVenda) return;

        if (!value) {
            this.contato.dadosVenda.dataFimContrato = undefined;
            return;
        }

        this.contato.dadosVenda.dataFimContrato = new Date(value);
    }

    private formatarDataParaInput(data: Date): string {
        if (!data) return '';
        const dataAjustada = new Date(data);
        dataAjustada.setHours(12, 0, 0, 0);
        return dataAjustada.toISOString().split('T')[0];
    }

    get valorTotal(): number | undefined {
        return this.contato?.dadosVenda?.valorTotal;
    }

    set valorTotal(value: number | undefined) {
        if (this.contato && this.contato.dadosVenda) {
            this.contato.dadosVenda.valorTotal = value;
        }
    }

    get valorTotalFormatado(): string {
        if (!this.valorTotal) return '';
        return this.valorTotal.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    }

    set valorTotalFormatado(value: string) {
        const numeroLimpo = value.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.');
        const numero = parseFloat(numeroLimpo);
        this.valorTotal = isNaN(numero) ? 0 : numero;
    }

    get observacao(): string | undefined {
        return this.contato?.dadosVenda?.observacao;
    }

    set observacao(value: string | undefined) {
        if (this.contato && this.contato.dadosVenda) {
            this.contato.dadosVenda.observacao = value;
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['idContato'] &&
            changes['idContato'].currentValue &&
            changes['idContato'].currentValue !== changes['idContato'].previousValue) {
            await this.inicializarModal();
        }
    }

    async inicializarModal() {
        this.carregando = true;
        this.contato = await this.contatosService.obterDetalhesContato(this.idContato, this.idLista);
        this.contatoJaConvertido = this.contato?.convertido ?? false;
        this.carregando = false;
    }

    async consultarMargem() {
        if (!this.permissaoService.hasPermission(EnumPermissao.ConsultarMargem)) {
            this.toastr.warning("Você não tem permissão para consultar margem", "Atenção");
            this.margem = undefined;
            return;
        }

        const temSaldo = await SaldoUtil.validarAcessoSegmentacao(this.saldoService, this.router, this.toastr);
        if (!temSaldo) {
            this.margem = undefined;
            return;
        }

        if (this.margem === undefined) {
            this.margem = true;
        } else if (this.margem === true) {
            this.margem = false;
        } else {
            this.margem = undefined;
        }

        await this.saldoService.obterSaldo();
    }

    onContatoConvertidoChange(event: any) {
        const isChecked = event.target.checked;
        if (isChecked) {
            this.showModal = true;            
        }
        else {
            this.showModal = true;
            this.ehRemoverVenda = true;
        }
    }

    abrirModalDadosVenda() {
        this.showModal = true;
    }

    closeDetails() {
        this.fecharDetalhes.emit();
    }

    closeModal(contatoFoiConvertido: boolean) {
        if(!this.ehRemoverVenda){
            if (!contatoFoiConvertido && !this.contatoJaConvertido) {
                this.contato!.convertido = false;
            }

            this.showModal = false;
        }
        else {
            this.closeModalRemoverVenda(false);
        }        
    }

    closeModalRemoverVenda(vendaFoiRemovida: boolean) {
        if(!vendaFoiRemovida) {
            this.contato!.convertido = true;
        }

        this.ehRemoverVenda = false;                
        this.showModal = false;
    }

    async converterContato() {
        if (!this.validarDadosVenda()) {
            return;
        }

        this.processandoVenda = true;
        const dataVenda = new Date();
        dataVenda.setHours(12, 0, 0, 0);
        this.contato!.dadosVenda.dataVenda = dataVenda;
        try{
            let response = await this.contatosService.converterContato(this.contato?.dadosVenda);
            if (response) {
                this.toastr.success("Dados de venda atualizados com sucesso");
                this.contato!.dadosVenda.idVenda = response;
                this.contatoConvertidoEvent.emit(this.idContato);
                this.contato!.convertido = true;
            this.contatoJaConvertido = true;
            this.closeModal(true);
            } else {
                this.toastr.error("Erro ao atualizar dados de venda");
            }
        }
        finally{
            this.processandoVenda = false;
        }
    }

    validarDadosVenda(): boolean {
        if (!this.contato?.dadosVenda) {
            this.toastr.error("Todos os campos são obrigatórios");
            return false;
        }

        if (this.contato?.dadosVenda.dataInicioContrato == null) {
            this.toastr.error("Data de início é obrigatório");
            return false;
        }

        if (this.contato?.dadosVenda.dataFimContrato == null) {
            this.toastr.error("Data de fim é obrigatório");
            return false;
        }

        if (this.contato?.dadosVenda.dataInicioContrato >= this.contato?.dadosVenda.dataFimContrato) {
            this.toastr.error("Data de início deve ser menor que data de fim");
            return false;
        }

        if (this.contato?.dadosVenda.parcelas == null || this.contato?.dadosVenda.parcelas <= 0 || isNaN(this.contato?.dadosVenda.parcelas)) {
            this.toastr.error("Parcelas é obrigatório");
            return false;
        }

        if (this.contato?.dadosVenda.valorTotal == null || this.contato?.dadosVenda.valorTotal <= 0 || isNaN(this.contato?.dadosVenda.valorTotal)) {
            this.toastr.error("Valor total é obrigatório");
            return false;
        }

        return true;
    }

    async removerVenda() {
        const paramDadosVenda: ParamRemoverDadosVenda = {
            idVenda: this.contato?.dadosVenda?.idVenda ?? 0,
            idContatoLista: this.contato?.dadosVenda?.idContatoLista ?? 0
        };

        if (!this.validarDadosRemoverVenda(paramDadosVenda)) {
            return;
        }

        this.processandoVenda = true;
        try{
            const response = await this.contatosService.removerVendaContato(paramDadosVenda);
            if(response){
                this.toastr.success("Venda removida com sucesso");
                this.contatoConvertidoEvent.emit(this.idContato);

                const dataVenda = new Date();
                dataVenda.setHours(12, 0, 0, 0);

                this.contato!.convertido = false;
                this.contatoJaConvertido = false;
                this.contato!.dadosVenda = {
                    idVenda: 0,
                    idContatoLista: this.contato?.dadosVenda.idContatoLista ?? 0,
                    dataVenda: dataVenda,
                    dataInicioContrato: undefined,
                    dataFimContrato: undefined,
                    parcelas: undefined,
                    valorTotal: undefined,
                    observacao: ''
                };

                this.closeModalRemoverVenda(true);
            }
            else {
                this.toastr.error("Erro ao remover venda");
            }
        }
        finally{
            this.processandoVenda = false;
        }
    }

    validarDadosRemoverVenda(dados: ParamRemoverDadosVenda): boolean {
        if(dados.idVenda == null || dados.idVenda <= 0) {
            this.toastr.error("Venda não encontrada.");
            return false;
        }

        if(dados.idContatoLista == null || dados.idContatoLista <= 0) {
            this.toastr.error("Contato não encontrado.");
            return false;
        }

        return true;
    }

    formatarValorTotalInput(event: any) {
        let valor = event.target.value;

        valor = valor.replace(/\D/g, '');
        const numero = parseFloat(valor) / 100;

        if (!isNaN(numero)) {
            event.target.value = numero.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });

            this.valorTotal = numero;
        }
    }

    formatarParcelasInput(event: any) {
        let valor = event.target.value;
        valor = valor.replace(/\D/g, '');
        const numero = parseInt(valor);
        this.parcelas = isNaN(numero) ? 0 : numero;
        event.target.value = this.parcelas;
    }

    async salvarAnotacao() {
        this.processandoAnotacao = true;
        let response = await this.contatosService.adicionarAnotacao(this.contato?.idContato ?? '', this.idLista, this.contato?.anotacoes ?? '');
        if (response) {
            this.toastr.success("Anotação salva com sucesso");
        } else {
            this.toastr.error("Erro ao salvar anotação");
        }
        this.processandoAnotacao = false;
    }
}
